<template>
 <div>
    <div class="container">
        <img src="/static/home/bookcase01.png" id="bookcase" style="width:100%">
        <a href="api/downloads/pamatky_archeologicke" dwonload>
            <img v-if="bookcaseLoaded" src="/static/home/book01.png" id="book01" v-bind:style="{position:'absolute',top:calculatePosition('top','book1')+'px',left:calculatePosition('left','book1')+'px',width:calculatePosition('width','book1')+'px'}" data-html="<img src='/static/home/pamatky_archeologicke.png'>" style="cursor:pointer"></a>
        <img v-if="bookcaseLoaded" src="/static/home/book02.png" id="book02" v-bind:style="{position:'absolute',top:calculatePosition('top','book2')+'px',left:calculatePosition('left','book2')+'px',width:calculatePosition('width','book2')+'px'}">
        <a href="api/downloads/sbirky_rudlofa_II" dwonload>
            <img v-if="bookcaseLoaded" src="/static/home/book03.png" id="book03" v-bind:style="{position:'absolute',top:calculatePosition('top','book3')+'px',left:calculatePosition('left','book3')+'px', width:calculatePosition('width','book3')+'px'}" data-html="<img src='/static/home/sbirky_rudolfa_II.png'>" style="cursor:pointer;"></a>
        <br><a href="https://www.freepik.com/free-photos-vectors/vintage">Vintage vector created by upklyak - www.freepik.com</a>&nbsp;&nbsp;&nbsp;
        <img src='/static/home/pamatky_archeologicke.png' width="1" height="1">
        <img src='/static/home/sbirky_rudolfa_II.png' width="1" height="1">
    </div><br>
    <div class="ui styled fluid accordion" id="list_view">
        <div class="title" style="text-align:center;">
            <i class="dropdown icon"></i>
           List view
        </div>
        <div class="content">
            <div  class="ui internally grid">
                <div class="three wide column"></div>
                <div class="five wide column">
                    <div class="ui segment">
                        <div class="ui internally grid">
                            <div class="five wide column">
                                <img src='/static/home/pamatky_archeologicke.png' class="ui small image" style="border:1px solid lightgray;">
                            </div>
                            <div class="ten wide column">
                                Památky Archaeologické<br>
                                Skupina historická<br>
                                Redigovali: Dr.Jan Květa Dr. Ant. Matejcek<br>
                                Rok: 1937<br><br>
                                Vydává Archaeologická komise České akademie v Praze a Archaeologický sbor Národního musea v Praze<br><br>
                                  <a href="api/downloads/pamatky_archeologicke" dwonload>Download</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="five wide column">
                    <div class="ui segment">
                        <div class="ui internally grid">
                            <div class="five wide column">
                                <img src='/static/home/sbirky_rudolfa_II.png' class="ui small image" style="border:1px solid lightgray;">
                            </div>
                            <div class="ten wide column">
                               Sbírky Rudolfova II<br>
                                Pokus o jejich identifikaci<br>
                                Březen - Květen 1937<br>
                                Úvodní studii napsal Phdr. J. Morávek<br><br>
                                
                                Nákladem kuratoria musea hlav. města Prahy.<br>
                                Vydáno s pomocí Městké spořitelny pražské.<br>
                                Tiskem Pražské městké tiskárny<br><br>
                                 <a href="api/downloads/sbirky_rudlofa_II" dwonload>Download</a>
                            </div>
                        </div>
                    </div>
                </div>
        
                <div class="three wide column"></div>
        
            </div>
        </div>
            
    </div>
</div>

</template>

<script>
    // import TheCarousel from '../components/TheCarousel.vue'
    export default {
        name: 'library',

        data() {
            return {
                rat: 1,
                bookcaseLoaded: false,
                list: false,
                interval:null
            }
        },
        methods: {
            calculatePosition: function(pos, book) {
                if (pos == 'top' && book == 'book1') return parseInt(797 * this.rat);
                if (pos == 'left' && book == 'book1') return parseInt(1476 * this.rat);
                if (pos == 'width' && book == 'book1') return parseInt(35 * this.rat);
                if (pos == 'top' && book == 'book2') return parseInt(678 * this.rat);
                if (pos == 'left' && book == 'book2') return parseInt(1565 * this.rat);
                if (pos == 'width' && book == 'book2') return parseInt(42 * this.rat);
                if (pos == 'top' && book == 'book3') return parseInt(678 * this.rat);
                if (pos == 'left' && book == 'book3') return parseInt(2585 * this.rat);
                if (pos == 'width' && book == 'book3') return parseInt(42 * this.rat);
            }
        },
        mounted() {
            // console.log($('bookcase').src);
            var localThis = this;

            $('#bookcase').on('load', function() {
                localThis.rat = $('#bookcase').width() / 4167;
                localThis.bookcaseLoaded = true;
                setTimeout(function() {
                    $('#book01').popup();
                    $('#book03').popup();
                    $('#list_view').accordion();
                    localThis.interval=setInterval(function() {
                        $('#book01').transition('tada')
                        setTimeout(function() {
                            $('#book03').transition('tada')
                        }, 1500)
                    }, 5000);
                }, 100);
                // $('#book01').popup();


            });


        },
        beforeDestroy() {
            clearInterval(this.interval);
        },
        components: {
            //  TheCarousel
        },
    }
</script>

<style scoped>
    P {
        text-align: justify;
    }

    .container {
        position: relative;
        width: 100%;
        width: 100vw;
        height: 100%;
        margin-top: -40px;
        text-align: right;
        font-size: 0.7rem;
    }

    .book1 {
        position: absolute;

    }
</style>



// WEBPACK FOOTER //
// src/router/library.vue